import { Chip } from "@heroui/react";
import type { ReactNode } from "react";
import { clsx } from "@/src/common/utils/clsx";

type BadgeTone = "success" | "warning" | "error" | "info" | "neutral" | "primary";

const TONE_CLASSES: Record<BadgeTone, string> = {
	success: "bg-success text-success-foreground",
	warning: "bg-warning text-warning-foreground",
	error: "bg-error text-error-foreground",
	info: "bg-info text-info-foreground",
	neutral: "bg-surface-muted text-muted-foreground",
	primary: "bg-primary-subtle text-primary",
};

interface BadgeProps {
	tone?: BadgeTone;
	children: ReactNode;
	className?: string;
}

/**
 * Soft status pill — colour roles come from Pencil tokens.
 * Use `Chip` (below) for interactive filter chips; `Badge` is static.
 */
export function Badge({ tone = "neutral", children, className }: BadgeProps) {
	return <Chip className={clsx("px-2 py-0.5 text-[11px] font-semibold tracking-wide", TONE_CLASSES[tone], className)}>{children}</Chip>;
}
